import {handleShowAnnouncementsPF,handleShowAnnouncementsMW} from "@dashboard/grid-components/announcements/AnnouncementUtil";


export const callHandleShowAnnouncements = ({
                                         calledBy,
                                         GUIInstrument,
                                         setGUIInstruments,
                                         setAggregatedSortedStocksCurrentClientTab,
                                         setLayouts,
                                         tabID,
                                         layouts,
                                         index,
                                         announcements,
                                         newAnnouncements,
                                         setIsUnmounting,
                                         stock,
                                                listRef
                                     }) => {
    if (calledBy === "PF") {
        handleShowAnnouncementsPF(
            stock.instrumentEntity,
            setAggregatedSortedStocksCurrentClientTab,
            setLayouts,
            tabID,
            layouts,
            index,
            announcements,
            newAnnouncements,
            setIsUnmounting,
            listRef
        );
    } else {
        handleShowAnnouncementsMW(
            GUIInstrument,
            setGUIInstruments,
            setLayouts,
            tabID,
            layouts,
            index,
            announcements,
            newAnnouncements,
            setIsUnmounting
        );
    }
};
